import React from 'react';
import './PediatricOrthopedics.css'; // Path to your CSS file

const PediatricCard = ({ title, subtitle, description, imageUrl,buttonurl}) => {
  return (
    <div className="containerPedia">
      <div className="image-sectionPedia card">
        <img src={imageUrl} alt="Doctor and Patient" className="background-imagePedia" />
      </div>

      <div className="content-cardPedia">
        <h2 className="titlePedia">{title}</h2>
        <p className="subtitlePedia">{subtitle}</p>
        <p className="descriptionPedia">{description}</p>
        <div className="button-containerPedia">
          <a
            href={buttonurl}
            className="read-more-btnPedia"
          >
            Read more
          </a>
        </div>
      </div>
    </div>
  );
};

export default PediatricCard;
